<template>
    <button-line :items="[
        {
            label: $ucfirst($t(afterFirstEncounter ? 'journeyProgress.progress' : 'journeyBehaviourChangeGoals.status')),
            route: {
                name: 'PatientRecordSmokingProgress',
                params: { patientId },
            },
        },
        {
            label: $ucfirst($t('journeyProgress.goalSetting')),
            route: {
                name: 'PatientRecordSmokingGoalSetting',
                params: { patientId },
            },
        }
    ]" v-bind="$attrs" />
</template>

<script>
import { mapGetters } from 'vuex';
import ButtonLine from "./ButtonLine";

/**
 * Component SmokingButtonLine.vue
 *
 * @module SmokingButtonLine
 * @date
 * @author
 * @copyright UniWeb BV 2023
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-TODO] app/src/APP_DASHBOARD/templates/components/Parts/SmokingButtonLine.vue
 *
 */

export default {
    name: "SmokingButtonLine",
    components: {
        ButtonLine,
    },
    computed: {
        ...mapGetters({
            patientId: 'patientSummary/id',
        }),
        afterFirstEncounter() {
            return parseInt(this.$store.getters['patientSummary/currentVersion']) > 2
        }
    }
};
</script>

<style lang="scss"></style>
